export const fields = {
  publishLater: "publishLater",
  publicationDate: "publicationDate",
  title: "title",
  image: "image",
  description: "description",
} as const
